// extracted by mini-css-extract-plugin
module.exports = {"link":"tJmAk","icon":"DKQ6m"};